import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/StockReport/WarehouseReportStockAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReportStockActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/StockReport/WarehouseReportStock")
	}

	render() {
		return (
			<Activity 
				name="WarehouseReportStock"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseReportStock"
				action="WarehouseReportStock"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReportStockActivity)
